(function(){
  var wrappers = document.querySelectorAll('.ckr-rail:not([data-ckr-klaar])');
  Array.prototype.forEach.call(wrappers, function(rail){
    rail.setAttribute('data-ckr-klaar','1');
    var track = rail.querySelector('.ckr-track');
    var vorige = rail.querySelector('.ckr-pijl--vorige');
    var volgende = rail.querySelector('.ckr-pijl--volgende');
    if(!track || !vorige || !volgende){ return; }

    function stap(){
      var kaart = track.querySelector('.ckr-item');
      var breedte = kaart ? kaart.getBoundingClientRect().width + 22 : track.clientWidth * 0.8;
      var zichtbaar = Math.max(1, Math.floor(track.clientWidth / breedte) - 1);
      return breedte * zichtbaar;
    }
    function lijnUit(){
      var foto = track.querySelector('.ckr-foto');
      if(foto && foto.offsetHeight){
        rail.style.setProperty('--ckr-pijl-top', (foto.offsetHeight / 2 + 2) + 'px');
      }
    }
    function ververs(){
      var max = track.scrollWidth - track.clientWidth - 2;
      vorige.disabled = track.scrollLeft <= 2;
      volgende.disabled = track.scrollLeft >= max;
    }
    vorige.addEventListener('click', function(){ track.scrollBy({left: -stap(), behavior:'smooth'}); });
    volgende.addEventListener('click', function(){ track.scrollBy({left: stap(), behavior:'smooth'}); });
    function bijwerken(){ lijnUit(); ververs(); }
    track.addEventListener('scroll', ververs, {passive:true});
    window.addEventListener('resize', bijwerken);
    window.addEventListener('load', bijwerken);
    bijwerken();
    setTimeout(bijwerken, 400);
    setTimeout(bijwerken, 1500);
  });
})();
